import React, { Component } from "react";
import { getInitialData } from "../services/api";
import LoadingIndicator from "../components/loading-indicator";

class Credits extends Component {
  constructor(props) {
    super(props);
    this.state = { content: null, loading: true };
  }

  componentDidMount() {
    getInitialData().then((data) => {
      const { page } = data || {};
      if (page) {
        let body = "";
        Object.keys(page).forEach((_id) => {
          const pageInfo = page[_id];
          if (pageInfo.id === "credits") {
            body = pageInfo.content || "";
          }
        });
        this.setState({ content: body, loading: false });
      } else {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="responsive-loading">
          <center>
            <LoadingIndicator />
          </center>
        </div>
      );
    }
    return (
      <div id="account-menu-container" className="terms responsive-page">
        {this.state.content && (
          <div
            className="credits"
            dangerouslySetInnerHTML={{ __html: this.state.content }}
          />
        )}
      </div>
    );
  }
}

export default Credits;
